import videojs from 'video.js';

const ClickableComponent = videojs.getComponent('ClickableComponent');
const Component = videojs.getComponent('Component');

function getIcon(iconsUrl, iconName) {
	return iconsUrl
		? `<svg width="100%" height="100%"><use href="${iconsUrl}#${iconName}" /></svg>`
		: iconName;
}

export default class ButtonPlay extends ClickableComponent {
	constructor(player, options) {
		super(player, options);

		this.player().on('play', () => {
			if (this.options_.iconsUrl) {
				this.el().innerHTML = getIcon(this.options_.iconsUrl, 'pause');
			} else {
				this.setAttribute('data-state', 'play');
			}
			this.el().dataset.icon = 'pause';
		});

		this.player().on(['pause', 'vast.contentEnd', 'vast.reset'], () => {
			if (this.options_.iconsUrl) {
				this.el().innerHTML = getIcon(this.options_.iconsUrl, 'play');
			} else {
				this.setAttribute('data-state', 'pause');
			}
			this.el().dataset.icon = 'play';
		});

		//блокируем большую кнопку плей на время рекламы, иначе при наличии преролл рекламы
		//при запуске видео, если кликнуть быстро дважды,
		//происходит запуск и рекламы, и основного видео одновременно
		this.player().on('vast.adBlockStart', () => {
			this.disable();
		});

		this.player().on(['vast.adBlockEnd', 'vast.adPodBlockEnd', 'vast.adsCancel'], () => {
			this.enable();
		});

	}

	handleClick() {
		this.player().paused()
			? this.player().play()
			: this.player().pause();
	}

	createEl() {
		return videojs.dom.createEl('button', {
			className: 'vjs-big-controls__play'
		});
	}
}

Component.registerComponent('ButtonPlay', ButtonPlay);
